export default "__VITE_ASSET__CPiizTtR__"